import { Text, TouchableOpacity, View, ImageBackground } from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import RNPickerSelect from "react-native-picker-select";
import { useNavigation } from "@react-navigation/native";
import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import api from "../../services/api";
import styles from "./styles";

const CardsPacotesSelos = () => {
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [seloCategory, setSeloCategory] = useState(null);
  const [loading, setLoading] = useState("");
  const [actives, setActives] = useState([]);
  const navigation = useNavigation();
  const intl = useIntl();

  const promotionalPacks = [
    { packName: "Básico", quantity: 530, price: 0.4 },
    { packName: "Intermediário", quantity: 1070, price: 0.34 },
    { packName: "Padrão", quantity: 2600, price: 0.3 },
    { packName: "Avançado", quantity: 6200, price: 0.25 },
    { packName: "Premium", quantity: 17000, price: 0.2 },
    { packName: "Supremo", quantity: 170000, price: 0.15 },
    { packName: "Master", quantity: 1500000, price: 0.1 },
    { packName: "Ultimate", quantity: 10000000, price: 0.05 },
  ];

  function formatLargeNumber(number) {
    if (number >= 1000000) {
      return (number / 1000000).toFixed(1) + "M";
    } else if (number > 9999) {
      return (number / 1000).toFixed(0) + "mil";
    }
    return number;
  }

  //Puxa as categorias e filtra pela categoria que inclui "Selo" no título
  const getSeloSustentavelCategory = async () => {
    const token = await AsyncStorage.getItem("JWT_TOKEN");
    try {
      const response = await api.get("/categories", {
        headers: { Authorization: `Bearer ${token}` },
      });

      const categories =
        Array.isArray(response.data) && Array.isArray(response.data[0])
          ? response.data[0]
          : [];

      const foundCategory = categories.find(
        (category) => category.name && category.name.includes("Selo")
      );

      setSeloCategory(foundCategory);
      return foundCategory;
    } catch (error) {
      console.error("Erro ao buscar categoria 'Selo Sustentável'", error);
      return null;
    }
  };

  //---------------------------------------------------------------

  // Puxa os ativos, filtrando para aparecerem apenas os da category com "Selo" no título
  const getActives = async () => {
    const token = await AsyncStorage.getItem("JWT_TOKEN");
    const seloCategory = await getSeloSustentavelCategory();

    if (!seloCategory) {
      console.error("Categoria 'Selo Sustentável' não encontrada");
      return;
    }

    setLoading(true);
    try {
      const response = await api.get(`/actives/getActives/${seloCategory.id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const activesList = response.data.active || [];

      setActives(activesList);
    } catch (error) {
      console.error("Erro ao buscar ativos", error);
    } finally {
      setLoading(false);
    }
  };
  //---------------------------------------------------------------

  useEffect(() => {
    getSeloSustentavelCategory();
    getActives();
  }, []);

  if (!seloCategory || !seloCategory.name.includes("Selo")) {
    return null;
  }

  const navigateToPurchase = (quantity, price, assetId) => {
    if (!assetId) {
      alert(
        intl.formatMessage({ id: "cardstransactionswallet.selecioneAtivo" })
      );
      return;
    }
    navigation.navigate("Purchase", {
      preSelectedQuantity: quantity,
      preSelectedPrice: price,
      selectedAssetId: selectedAsset,
      disableInputs: true,
    });
  };

  return (
    <View style={styles.containerCardsPacotes}>
      <View style={styles.containerCardsPacotes}>
        {promotionalPacks.map((pack, index) => {
          const background =
            index % 2 === 0
              ? require("../../../assets/cardPacoteBgLight.png")
              : require("../../../assets/cardPacoteBgDark.png");

          const isEven = index % 2 === 0;

          const totalValue = pack.quantity * pack.price;

          return (
            <ImageBackground
              key={index}
              source={background}
              style={styles.cardContainer}
              imageStyle={{ borderRadius: 8 }}
            >
              <Text
                style={[
                  { fontSize: 20 },
                  isEven ? styles.txtGeral : styles.txtGeralLight,
                ]}
              >
                <FormattedMessage id="cardsPacotesSelos.titlePacotePromo" />
                {pack.packName}
              </Text>
              <View style={{ alignItems: "center" }}>
                <Text
                  style={[
                    styles.headerQuantSelos,
                    isEven ? styles.txtGeral : styles.txtGeralLight,
                  ]}
                >
                  {formatLargeNumber(pack.quantity)}
                </Text>
                <Text
                  style={[
                    isEven ? styles.txtGeral : styles.txtGeralLight,
                    { marginBottom: 12 },
                  ]}
                >
                  <FormattedMessage id="cardsPacotesSelos.subTxtSelosCarbNeutro" />
                </Text>
                <View style={styles.containerPorSifraoValor}>
                  <Text style={isEven ? styles.txtGeral : styles.txtGeralLight}>
                    <FormattedMessage id="cardsPacotesSelos.porTxt" />
                  </Text>
                  <Text
                    style={[
                      isEven ? styles.txtGeral : styles.txtGeralLight,
                      { fontSize: 22 },
                    ]}
                  >
                    <FormattedMessage id="cardsPacotesSelos.sifraoTxt" />
                  </Text>
                  <Text
                    style={[
                      isEven ? styles.txtGeral : styles.txtGeralLight,
                      { fontSize: 24 },
                    ]}
                  >
                    {new Intl.NumberFormat("pt-BR").format(totalValue)}
                  </Text>
                </View>
              </View>

              <View style={{ marginTop: 20 }}>
                <FormattedMessage id="cardsPacotesSelos.placeholderPicker">
                  {(placeholder) => (
                    <RNPickerSelect
                      onValueChange={(value) => setSelectedAsset(value)}
                      items={actives
                        .filter((asset) => asset.single_value === pack.price)
                        .map((asset) => ({
                          label: asset.name_token,
                          value: asset.id,
                          key: asset.id.toString(),
                        }))}
                      placeholder={{
                        label: Array.isArray(placeholder)
                          ? placeholder.join("")
                          : placeholder,
                        value: "",
                      }}
                      value={selectedAsset || ""}
                    />
                  )}
                </FormattedMessage>
              </View>
              <View style={styles.containerSubTexto}>
                <Text style={isEven ? styles.txtGeral : styles.txtGeralLight}>
                  <FormattedMessage id="cardsPacotesSelos.txtSeloEquivale" />
                </Text>
                <Text style={isEven ? styles.txtGeral : styles.txtGeralLight}>
                  <FormattedMessage id="cardsPacotesSelos.txtSeloPreco" />
                  {pack.price.toFixed(2)}
                </Text>
              </View>
              <View>
                <TouchableOpacity
                  onPress={() =>
                    navigateToPurchase(pack.quantity, pack.price, selectedAsset)
                  }
                  style={
                    isEven
                      ? styles.btnComprarPacote
                      : styles.btnComprarPacoteLight
                  }
                >
                  <Text
                    style={
                      isEven
                        ? styles.txtBtnComprarPacote
                        : styles.txtBtnComprarPacoteLight
                    }
                  >
                    <FormattedMessage id="cardsPacotesSelos.btnComprarPacote" />
                  </Text>
                </TouchableOpacity>
              </View>
            </ImageBackground>
          );
        })}
      </View>
    </View>
  );
};

export default CardsPacotesSelos;
